import axios, { AxiosRequestConfig } from "axios";
import { SERVER_URL } from "Constants";
import { IUserResult } from "Models/Store";

export type MonitorPaygPrice = {
	id: string;
	name: string;
	billingPeriod: number;
	billingAmount: number;
}

export async function getAccount(requestOptions: AxiosRequestConfig) {
	const url = `${SERVER_URL}/api/account/me`;
	return await axios.get<IUserResult>(url, requestOptions)
}
